const locale = {
  placeholder: 'Please select',
  selectAll: 'Select All',
  selected: 'Selected',
  search: 'Search',
  numberOf: '{number} items',
  maxLengthError: 'The maximum number cannot exceed {maxLength}',
  defaultChildren: 'Dropdown content, to be implemented by the caller',
  removeAll: 'Remove All',
  cancel: 'Cancel',
  confirm: 'OK'
};

export default locale;
